// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__+jqTW","modal":"modal_modal__gQbyu","burger_btn":"modal_burger_btn__bqv8-"};